import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Amplify, Auth } from "aws-amplify";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import {
	Navbar,
	Nav,
	Container,
	NavDropdown,
	Image,
	Spinner,
	Button,
} from "react-bootstrap";
import LandingPage from './components/LandingPage';
import ControlPanel from "./components/ControlPanel";
import BakerQuoteRequestList from "./components/BakerQuoteRequest/List";
import BakerQuoteRequestDetail from "./components/BakerQuoteRequest/Detail";
import CustomerQuoteRequestList from "./components/CustomerQuoteRequest/List";
import CustomerQuoteRequestDetail from "./components/CustomerQuoteRequest/Detail";
import CreateAccount from "./components/ControlPanel/CreateAccount";
import BakeryList from "./components/ControlPanel/BakeryList";
import AccountList from "./components/ControlPanel/AccountList";
import BakeryLoginForm from './components/BakeryLoginForm';
// import InquiriesList from './components/_InquiriesList';
import RegisterForm from './components/RegisterForm';
import BakeryCreation from './components/BakeryCreation';
import QuoteRequest from './components/QuoteRequest';
import BakeryResults from './components/_BakeryResults';
import AboutUs from './components/AboutUs';
import { AppContext } from "./context/appContext";
import awsExports from './aws-exports';
import BakerySearch from './components/BakerySearch';
import BakeryFavs from "./components/BakeryFavs";
import ContactUs from './components/ContactUs';
import { USER_TYPE } from "./utils/constants";
import BakeryJoin from './components/BakeryJoin';
import GenericQuoteRequest from './components/GenericQuoteRequest';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomCakeCreator from './components/CustomCakeCreator';
import RollinInDaisies from './components/RollinInDaisies';
import CustomGradCakeCreator from './components/CustomGradCakeCreator';
import { ThankYouPage } from './components/ThankYouPage';
import { CancelledPage } from './components/CanceledPage';  // Note spelling: Cancelled with two Ls
import PaymentSuccess from "./components/PaymentSuccess";
import VerifyAccount from "./components/VerifyAccount";
import CustomGradCakes from "./components/CustomGradCakes";
import BakerResources from './components/BakerResourcePage';
import ForgotPassword from './components/ForgotPassword';
import ResetPasswordConfirm from './components/ResetPasswordConfirm';
import ResetPasswordSuccess from './components/ResetPasswordSuccess';



Amplify.configure(awsExports);

function App() {
  const [globalLoading, setGlobalLoading] = useState(false);
  const [username, setUsername] = useState(null);
  const [userType, setUserType] = useState(null); 
  const [userSub, setUserSub] = useState(null); 

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(user => {
        const { username, signInUserSession } = user;
        setUsername(username);
        setUserType(
					signInUserSession?.["accessToken"]?.["payload"]?.[
						"cognito:groups"
					]?.[0] || "admin",
				);
        setUserSub(
					signInUserSession["accessToken"]["payload"]["sub"],
				);
      })
      .catch(() => {
        setUsername(null);
        setUserType(null);
      });
  }, []);

  const handleLogout = async () => {
    await Auth.signOut();
    setUsername(null);
    setUserType(null);
    window.location.href = '/';
  };

  return (
			<AppContext.Provider
				value={{
					username,
					userType,
					setUsername,
					setUserType,
					userSub,
					setUserSub,
					setGlobalLoading,
				}}>
				{globalLoading && (
					<div
						style={{
							position: "fixed", // 🔥 fixed so it covers the whole screen
							top: 0,
							left: 0,
							width: "100vw",
							height: "100vh",
							zIndex: 9999,
							backgroundColor: "rgba(255, 255, 255, 0.8)",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
						}}>
						<Spinner
							animation="border"
							variant="primary"
							style={{ width: "3rem", height: "3rem" }}
						/>

						{/* Cupcake Image */}
						<img
							src="/faith.png" // ✅ make sure this path matches your public folder
							alt="Cupcake"
							className="cupcake-bounce"
							style={{
								marginTop: "24px",
								height: "100px", // Adjust size here
							}}
						/>

						<p style={{ fontWeight: 500, marginTop: "12px", color: "#555" }}>
							Baking up your request…
						</p>
					</div>
				)}

				<Router>
					{/* Navbar with soft black text and no border */}
					<Navbar
						expand="lg"
						style={{
							backgroundColor: "#f8f9fa",
							borderBottom: "none",
							boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
						}}
						className="mb-4">
						<Container style={{ borderBottom: "none" }}>
							<Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
								<Image
									src="/cakerylogo.png"
									alt="Cakery Logo"
									style={{ maxWidth: "40px", marginRight: "10px" }}
								/>
								<span style={{ color: "#333333", fontWeight: "bold" }}>Cakery</span>
							</Navbar.Brand>
							<Navbar.Toggle aria-controls="basic-navbar-nav" />
							<Navbar.Collapse id="basic-navbar-nav" className="text-center">
								<Nav className="me-auto d-flex flex-column flex-lg-row align-items-center align-items-lg-start gap-2">
									<Nav.Link
										className="nav-link-custom-font"
										as={Link}
										to="/about-us"
										style={{ color: "#163C75" }}
										onClick={() => document.querySelector(".navbar-toggler")?.click()}>
										About Us
									</Nav.Link>

									{userSub && userType === USER_TYPE.BAKERY && (
										<Nav.Link
											className="nav-link-custom-font"
											as={Link}
											to="/baker-resources"
											style={{ color: "#163C75" }}
											onClick={() => document.querySelector(".navbar-toggler")?.click()}>
											Baker Resources
										</Nav.Link>
									)}

									{userSub && userType === USER_TYPE.CUSTOMER && (
										<Nav.Link
											className="nav-link-custom-font"
											as={Link}
											to="/bakery-favs"
											style={{ color: "#163C75" }}
											onClick={() => document.querySelector(".navbar-toggler")?.click()}>
											My Favorite Bakeries
										</Nav.Link>
									)}

									{userSub && userType === USER_TYPE.BAKERY && (
										<Nav.Link
											onClick={() => document.querySelector(".navbar-toggler")?.click()}
											as={Link}
											to="/bakery-creation"
											style={{ color: "#163C75" }}>
											Manage Bakery Profile
										</Nav.Link>
									)}
									{userSub && userType === USER_TYPE.ADMIN && (
										<Nav.Link
											as={Link}
											to="/control/account"
											style={{ color: "#163C75" }}>
											Control Panel
										</Nav.Link>
									)}

									{/* 
									<Nav.Link as={Link} to="/bakery-search" style={{ color: "#333333" }}>
										Bakery Search
									</Nav.Link>
									<Nav.Link as={Link} to="/bakery-results" style={{ color: "#333333" }}>
										Bakery Results
									</Nav.Link>
									<Nav.Link as={Link} to="/quote-request" style={{ color: "#333333" }}>
										Quote Request
									</Nav.Link>
									<Nav.Link as={Link} to="/inquiries-list" style={{ color: "#333333" }}>
										Inquiries List
									</Nav.Link>
                  <Nav.Link as={Link} to="/test-with-working-search" style={{ color: "#333333" }}>
										Test New With Search
									</Nav.Link>
									{userType === USER_TYPE.BAKERY && (
										<Nav.Link
											as={Link}
											to="/bakery-creation"
											style={{ color: "#333333" }}>
											Bakery Creation
										</Nav.Link>
									)} */}
								</Nav>

								<Nav className="ms-auto d-flex align-items-center gap-2 mt-2 mt-lg-0">
									{username ? (
										<NavDropdown
											title={
												<span className="text-muted small">
													Signed in as <strong>{username}</strong>
												</span>
											}
											id="user-dropdown"
											align="end"
											className="mt-1">
											<NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
										</NavDropdown>
									) : (
										<>
											<Button
												as={Link}
												to="/login"
												className="rounded-pill px-3 btn-outline-pink"
												variant="outline-primary"
												onClick={() => document.querySelector(".navbar-toggler")?.click()}>
												Sign In
											</Button>

											<NavDropdown
												title="Sign Up"
												id="signup-dropdown"
												align="end"
												className="signup-dropdown-style">
												<NavDropdown.Item
													as={Link}
													to="/bakery-creation"
													onClick={() => document.querySelector(".navbar-toggler")?.click()}>
													Sign Up as Bakery
												</NavDropdown.Item>
												<NavDropdown.Item
													as={Link}
													to="/register-form"
													onClick={() => document.querySelector(".navbar-toggler")?.click()}>
													Sign Up as Customer
												</NavDropdown.Item>
											</NavDropdown>
										</>
									)}
								</Nav>
								<Nav>
									{/* {username ? (
										<NavDropdown
											title={`Hello, ${username}`}
											id="basic-nav-dropdown"
											style={{ color: "#333333" }}>
											<NavDropdown.Item
												onClick={handleLogout}
												style={{ color: "#333333" }}>
												Logout
											</NavDropdown.Item>
										</NavDropdown>
									) : (
										""
									)} */}
								</Nav>
							</Navbar.Collapse>
						</Container>
					</Navbar>
					<Routes>
						<Route path="/" element={<LandingPage />} />
						<Route path="/about-us" element={<AboutUs />} />
						<Route path="/contact-us" element={<ContactUs />} />
						<Route path="/custom-cake-creator" element={<CustomCakeCreator />} />
						<Route path="/rollin-in-daisies" element={<RollinInDaisies />} />
						<Route path="/quote-request" element={<QuoteRequest />} />
						<Route path="/quote/:bakeryName" element={<QuoteRequest />} />
						<Route path="/bakery-search" element={<BakerySearch />} />
						<Route path="/bakery-favs" element={<BakeryFavs />} />
						<Route path="/bakery-join" element={<BakeryJoin />} />
						<Route path="/genericquoterequest" element={<GenericQuoteRequest />} />
						<Route
							path="/custom-grad-cake-creator"
							element={<CustomGradCakeCreator />}
						/>
						<Route path="/thank-you" element={<ThankYouPage />} />
						<Route path="/cancelled" element={<CancelledPage />} />
						<Route path="/payment-success" element={<PaymentSuccess />} />
						<Route path="/verify-account" element={<VerifyAccount />} />
						<Route path="/login" element={<BakeryLoginForm />} />
						<Route path="/forgot-password" element={<ForgotPassword />} />
						<Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />
						<Route path="/reset-password-success" element={<ResetPasswordSuccess />} />
						<Route path="/custom-grad-cakes" element={<CustomGradCakes />} />
						<Route path="/baker-resources" element={<BakerResources />} />
						<Route path="/b/quote-request/list" element={<BakerQuoteRequestList />} />
						<Route
							path="/b/quote-request/:id/:bakeryName"
							element={<BakerQuoteRequestDetail />}
						/>
						<Route
							path="/c/quote-request/list"
							element={<CustomerQuoteRequestList />}
						/>
						<Route
							path="/c/quote-request/:id/:bakeryName"
							element={<CustomerQuoteRequestDetail />}
						/>

						{!userSub && (
							<>
								<Route path="/register-form" element={<RegisterForm />} />
							</>
						)}

						{/* <Route path="/inquiries-list" element={<InquiriesList />} /> */}
						{/* <Route
							path="/bakery-results"
							element={<BakeryResults />}
							/>
							<Route
							path="/bakery-results/:product/:eventType/:servings"
							element={<BakeryResults />}
							/> */}
						{/* {userSub && userType === USER_TYPE.BAKERY && (
							<Route path="/bakery-creation" element={<BakeryCreation />} />
						)} */}
						<Route path="/bakery-creation" element={<BakeryCreation />} />
						{userSub && userType === USER_TYPE.ADMIN && (
							<>
								<Route path="/control" element={<ControlPanel />} />
								<Route path="/control/bakery" element={<BakeryList />} />
								<Route path="/control/bakery/:userSub" element={<BakeryCreation />} />
								<Route path="/control/account" element={<AccountList />} />
								<Route path="/control/account/create" element={<CreateAccount />} />
							</>
						)}
					</Routes>
				</Router>
			</AppContext.Provider>
		);
}

export default App;
